import { decisionTokens } from './presentation';
import { ActionTarget, CodeActionPayload, DecisionOutcome } from './types';

export type DecisionValues = {
    reason?: string;
    note?: string;
    approval_reference?: string;
    reference?: string;
    statement_confirmed?: boolean;
};

export const decisionPayload = (
    target: ActionTarget,
    values: DecisionValues,
    outcome: DecisionOutcome | null
): CodeActionPayload => {
    const { row } = target;
    const actionName = target.action.action;
    const reason =
        (actionName === 'note' ? values.note : values.reason)?.trim() ??
        '';
    const action = target.action;
    if (action.review_scope !== 'code') {
        throw new Error('Refresh the page to use per-code actions.');
    }
    if (
        action.action === 'resolve_warning' &&
        (!outcome || !action.allowed_outcomes?.includes(outcome))
    ) {
        throw new Error('Choose an available decision.');
    }
    const payload: CodeActionPayload = {
        ...decisionTokens(row),
        charge_id: row.charge_id,
        source: 'gateway',
        action: action.action,
        reason,
        ...(values.note?.trim() && { note: values.note.trim() })
    };
    if (action.action !== 'resolve_warning' || !outcome) return payload;
    payload.outcome = outcome;
    payload.warning_kinds = action.warning_kinds ?? [];
    if (action.approval_reference_required_outcomes?.includes(outcome)) {
        payload.approval_reference = values.approval_reference?.trim();
    }
    if (action.condition_confirmation && action.reference_required_outcomes?.includes(outcome)) {
        if (!values.statement_confirmed || !values.reference?.trim())
            throw new Error('Confirm the clinical statement and reference.');
        const { contract_version, criterion_id, service_month } = action.condition_confirmation;
        payload.condition_confirmation = {
            contract_version,
            criterion_id,
            service_month,
            criterion_state: 'met',
            statement_confirmed: true,
            evidence_references: [{ type: 'external', reference: values.reference.trim() }]
        };
    }
    return payload;
};
